import React from "react";
import { Route, Routes } from "react-router-dom";

import Chatting from "../views/page/board/Chatting";
import InquiryCate from "../views/page/board/InquiryCate";
import Inquiry from "../views/page/board/Inquiry";
import InquiryWrite from "../views/page/board/InquiryWrite";
import Consult from "../views/page/board/Consult";
import ConsultWrite from "../views/page/board/ConsultWrite";

function RouterBoard() {
  return (
    <>
      <Routes>
        <Route exact path="/Chatting" element={<Chatting />} />
        <Route exact path="/InquiryCate" element={<InquiryCate />} />
        <Route exact path="/Inquiry" element={<Inquiry />} />
        <Route exact path="/Inquiry/Write" element={<InquiryWrite />} />
        <Route exact path="/Inquiry/Write/:board_seq" element={<InquiryWrite />} />
        <Route exact path="/Consult" element={<Consult />} />
        <Route exact path="/Consult/Write" element={<ConsultWrite />} />
        <Route exact path="/Consult/Write/:consu_seq" element={<ConsultWrite />} />
      </Routes>
    </>
  );
}

export default RouterBoard;